import Vue from 'vue'
import * as API from '@/endpoints'
import Axios from 'axios'
import Store from '@/store'
import Cons from '@/constants.json'

export default {
  namespaced: true,
  state: {
    info: {
      isLoading: false,
      isBookmarking: false,
      isHonoraryLoading: false,
      honorary: [],
      data: {
        about_me: null
      },
      userAdvocacies: {},
      userOrganization: {},
      alliance: {},
      userFollowers: {},
      userFollowing: {},
      followCount: {},
      previousUserId: '',
      country: {}
    },
    myStuff: {
      isLoading: false,
      data:{}
    },
    myPrivateTimeline: {
      isLoading: false,
      data: {}
    },
    myTimeline: {
      isLoading: false,
      data: {}
    },
    myBadges: {
      isLoading: false,
      data: []
    },
    myGroupType: {
      interest: {},
      event: {},
      alliance: {},
      public: {},
      all: {}
    },
    showAvatarPicker: false
  },
  mutations: {
    setUserGroup(state, v) {
      Vue.set(state.myGroupType, 'all', v.data);
    },
    setUserGroupType(state, v) {
      switch(v.type ) {
        case 'interest':
          Vue.set(state.myGroupType, 'interest', v.data);
          break;
        case 'event':
          v.data.careplans = v.data.data
          Vue.set(state.myGroupType, 'event', v.data);
          break;
        case 'alliance':
          Vue.set(state.myGroupType, 'alliance', v.data);
          break;
        case 'public':
          Vue.set(state.myGroupType, 'public', v.data);
          break;
      }
    },
    setIsLoadingMyPrivateTimeline(state, v) {
      Vue.set(state.myPrivateTimeline, 'isLoading', v);
    },
    setDataMyPrivateTimeline(state, v) {
      Vue.set(state.myPrivateTimeline, 'data', v);
    },
    pushItemToPrivateTimeline(state, v){
      if (state.myPrivateTimeline.data.careplan_item)
        state.myPrivateTimeline.data.careplan_item.push(v)
    },
    setIsLoadingMyTimeline(state, v) {
      Vue.set(state.myTimeline, 'isLoading', v);
    },
    setDataMyTimeline(state, v) {
      Vue.set(state.myTimeline, 'data', v);
    },
    pushItemToTimeline(state, v){
      if (state.myTimeline.data.careplan_item)
        state.myTimeline.data.careplan_item.push(v)
    },
    setIsLoadingMyStuff(state, v) {
      Vue.set(state.myStuff, 'isLoading', v);
    },
    setDataMyStuff(state, v) {
      Vue.set(state.myStuff, 'data', v);
    },
    setIsLoadingInfo(state, v) {
      Vue.set(state.info, 'isLoading', v);
    },
    setHonorary(state, v) {
      Vue.set(state, 'honorary', v)
    },
    setHonoraryLoader(state, v) {
      Vue.set(state, 'isHonoraryLoading', v)
    },
    setBookmarkId (state, v) {
      Vue.set(state.info.data, 'bookmark_id', v)
    },
    setBookmarked(state, v) {
      Vue.set(state.info.data,'bookmarked',v);
    },
    setIsBookmarking(state, v) {
      Vue.set(state.info,'isBookmarking',v);
    },
    setInfoData(state, v) {
      Vue.set(state.info, 'data', v);
    },
    setUserFollowers(state, v) {
      Vue.set(state.info, 'userFollowers', v);
    },
    setUserFollowing(state, v) {
      Vue.set(state.info, 'userFollowing', v);
    },
    setFollowCount(state, v) {
      Vue.set(state.info, 'followCount', v);
    },
    setFollower(state, v) {
      if (v) state.info.followCount.followers += 1;
      if (!v) state.info.followCount.followers -= 1;
    },
    setInfoPreviousUserId(state, v) {
      Vue.set(state.info, 'previousUserId', v);
    },
    setUserOrganization(state, v) {
      Vue.set(state.info, 'userOrganization', v);
    },
    setUserAdvocacies(state, v) {
      Vue.set(state.info, 'userAdvocacies', v);
    },
    setBadges(state, v) {
      Vue.set(state.myBadges, 'data', v);
    },
    setCountry(state, v) {
      Vue.set(state.info, 'country', v)
    },
    setAvatarPicker(state, v) {
      Vue.set(state, 'showAvatarPicker', v)
    }
  },
  actions: {
    requestToJoinCareteam({commit, dispatch, state}, payload){
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.careteamRequest + "/" + payload.private_careplan_id, {
          journal_id: payload.journal_id
        })
        .then(res => resolve(res.data), error => reject(error))
      })
    },
    bookmark({ commit, dispatch, state }) {
      return new Promise((resolve, reject)=> {
        let user = state.info.data;
        let isBookmarked = user.bookmarked;
        let method = isBookmarked? 'delete': 'post';
        let bookmark_id = user.bookmark_id;
        let url = API.endpoints.bookmark + (isBookmarked ? '/' + bookmark_id: '');

        let data = {
          item_id : user.id,
          type : 'person'
        };
        
        commit('setIsBookmarking', true);
        Axios({ method:method, url: url, data:data }).then(
          res => {
            if (!isBookmarked) {
              commit('setBookmarkId', res.data.id);
            }
            commit('setBookmarked', isBookmarked? 0:1);
            commit('setIsBookmarking', false);
            resolve(res.data);
          },
          error => {
            commit('setIsBookmarking', false);
            dispatch('exceptionHandling', { _err: error }, { root: 1 });
            reject(error);
          }
        );

      });
    },
    getMyPrivateCareplan({dispatch, commit, state}, id){
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + id)
          .then(res => {
            resolve(res.data)
          },
          error => {
            reject(error)
          })
      })
    },
    getMyPrivateTimeline({ dispatch, commit, state }, payload) {
      return new Promise((resolve, reject)=> {
        var filter = payload.filter == 'all' ? '&exclude_type=gallery,document,share_activity' :
          payload.filter == 'post' ? '&exclude_type=gallery,document,share_activity&filter=attachment_type:document:out' :
          payload.filter == 'document' ? '&type=attachment&filter=attachment_type:document' : 
          payload.filter == 'checkin' ? '&type=check_in' : ''

        commit('setDataMyPrivateTimeline',{});
        commit('setIsLoadingMyPrivateTimeline', true);
        Axios.get(API.endpoints.careplan + '/' + payload.user.private_careplan_id + '/item?brand_id='+ Cons[0].BRAND_ID + filter +'&asc=0&sort_by=rrule_parsed_date').then(
          res=> {
            commit('setDataMyPrivateTimeline',res.data);
            commit('setIsLoadingMyPrivateTimeline', false);
            resolve(res.data);
          },
          error=> {
            commit('setIsLoadingMyPrivateTimeline', false);
            dispatch('exceptionHandling', { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    getMyTimeline({ dispatch, commit, state }, payload) {
      console.log(">>>>>>>>>>", payload)
      return new Promise((resolve, reject)=> {
        commit('setDataMyTimeline',{});
        commit('setIsLoadingMyTimeline', true);
        Axios.get(API.endpoints.careplan + '/' + payload.careplan_id + '/item?brand_id='+ Cons[0].BRAND_ID +'&exclude_type=gallery,document,share_activity&asc=0&sort_by=rrule_parsed_date').then(
          res=> {
            commit('setDataMyTimeline',res.data);
            commit('setIsLoadingMyTimeline', false);
            resolve(res.data);
          },
          error=> {
            commit('setIsLoadingMyTimeline', false);
            dispatch('exceptionHandling', { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    getMyStuff ({ dispatch, commit, state }, journal_id) {
      return new Promise((resolve, reject) => {
        commit('setDataMyStuff', {});
        commit('setIsLoadingMyStuff', true);
        Axios.get(API.endpoints.journal + '/' + journal_id + '/careplans?sort_by=updated_at').then(
          res => {
            commit('setDataMyStuff', res.data);
            commit('setIsLoadingMyStuff', false);
            resolve(res.data);
          },
          error => {
            commit('setIsLoadingMyStuff', false);
            dispatch('exceptionHandling', { _err: error }, { root: 1 });
            reject(error);
          }
        )
      })
    },
    getUserInfo ({ commit, dispatch, state }, id) {
      // console.log('getUserInfo...',id);
      return new Promise((resolve, reject) => {
        commit('setInfoData',{});
        commit('setIsLoadingInfo', true);
        commit('setHonoraryLoader', true)

        Axios.get(API.endpoints.user + '/' + id).then(
          res => {
            // console.log('getUserInfo...', res.data);
            Axios.get(API.endpoints.user + '/' + id + '/state')
              .then(r => {
                commit('setInfoData', {...res.data, ...r.data});
                commit('setInfoPreviousUserId', id);
                commit('setIsLoadingInfo', false);

                resolve(res.data)
              })
          },
          error => {
            commit('setIsLoadingInfo', false);
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserOrganization ({ commit, dispatch, state }, {id}) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.journal + '/' + id + '/careplans?sort_by=updated_at&type=alliance&exclude_type=report_concern,suggestion_box,menu,video,maintainance').then(
          res => {
            commit('setUserOrganization', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    setPrimaryOrg({ commit, dispatch }, {id, data}){
      if( !id ) return false;

      return new Promise((resolve, reject) => {
        Axios.put(API.endpoints.user + '/' + id, data).then(
          res => {
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserFollowCount({commit}, {id}) {
      if( !id ) return false;

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/' + id + '/follow/count', null, {
          headers: {'Cache-Control': 'no-cache'}
        }).then(
          res => {
            commit('setFollowCount', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserFollowing({ commit, dispatch, state }, {id}) {
      if( !id ) return false;

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/' + id + '/following').then(
          res => {
            commit('setUserFollowing', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserFollowers({ commit, dispatch, state }, {id}) {
      if( !id ) return false;

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/' + id + '/followers').then(
          res => {
            commit('setUserFollowers', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    followUser(context, { userId }) {
      return Axios.post(`${API.endpoints.base}/follow/user/${userId}`)
      .then(response => {
        context.commit('setFollower', true);
        return Promise.resolve(response)
      })
      .catch(error => {
        context.dispatch("exceptionHandling", { _err: error }, { root: 1 });
        return Promise.reject(error);
      })
    },
    unfollowUser(context, { userId }) {
      return Axios.delete(`${API.endpoints.base}/unfollow/user/${userId}`)
      .then(response => {
        context.commit('setFollower', false);
        return Promise.resolve(response)
      })
      .catch(error => {
        context.dispatch("exceptionHandling", { _err: error }, { root: 1 });
        return Promise.reject(error);
      })
    },
    getUserAdvocacies ({ commit, dispatch, state }, {id}) {
      if( !id ) return false;

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.journal + '/' + id + '/careplans?sort_by=updated_at&type=interest').then(
          res => {
            commit('setUserAdvocacies', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserOrg ({ commit, dispatch, state }, {id}) {
      if( !id ) {
        state.info.alliance = null
        return false;
      }

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + id ).then(
          res => {
            state.info.alliance = res.data
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserGroupList({ commit, dispatch, state, rootState }, {id, type, asc}) {
      if( !id ) return false;

      let profileId = _.get(state, "info.data.id")
      let currentUserId = _.get(rootState, "user.info.id")
      if (profileId !== currentUserId) {
        commit('setUserGroup', {
          data: { 
            careplans: [] 
          } 
        })
        return false;
      }
      

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.journal + '/' + id + '/careplans?brand_id='+Cons[0].BRAND_ID+'&sort_by=updated_at&section=group&asc=' + asc).then(
          res => {
            // console.log(id, res.data)
            console.log(">>>>>>>>>>1", res.data)
            let resData = res.data

            Axios.get(API.endpoints.journal + '/' + id + '/organizations?brand_id='+Cons[0].BRAND_ID).then(
            // Axios.get(API.endpoints.journal + '/' + id + '/careplans?type=organization&sort_by=updated_at&section=group&asc=' + asc).then(
              
              res1 => {
                resData.careplans = [...resData.careplans, ...res1.data.careplans]
                resData.total += res1.data.total
                commit('setUserGroup', {type, data: resData })
                resolve(resData)
              },
              e => {
                dispatch('exceptionHandling', { _err: error }, { root: 1 })
                reject(error)
              })

          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserGroupByType ({ commit, dispatch, state }, {id, type}) {
      if( !id ) return false;
      return new Promise((resolve, reject) => {
        if(type == 'event'){
            dispatch('events/getListOfEvents','accepted', { root: 1 }).then(res =>{
              resolve(res)
            },error =>{
              reject(error)
            })
        }else{
          Axios.get(API.endpoints.journal + '/' + id + '/careplans?sort_by=updated_at&access=public&section=group&type='+type).then(
            res => {
              commit('setUserGroupType', {type, data:res.data})
              resolve(res.data)
            },
            error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        }
      })
    },
    getBadges({commit, rootState}, { journalId, userId }) {
      let badges = []
      let brand = rootState.user.brandPlan;
      brand.subscribed = true;
      // badges.push( brand )
      return Axios.get(API.endpoints.journal + '/' + journalId + '/careplans?sort_by=updated_at&type=city,province,country')
      .then(res => {
        badges = badges.concat(res.data.careplans.map(item => {
          let plan = item.careplan
          plan.subscribed = true;
          return plan
        }))
        return Promise.resolve(res.data)
      })
      .then(() => {
        return Axios.get(API.endpoints.developedPlans + '?group_id=1&section=group&type=badge&published=1&user_id='+userId)
      })
      .then(res => {
        // console.log(res.data)
        badges = badges.concat(res.data.careplan)
        return Promise.resolve(res.data)
      })
      .then(() => {
        commit('setBadges', badges)
        return Promise.resolve(badges)
      })
      .catch( error => {
        dispatch('exceptionHandling', { _err: error }, { root: 1 });
        return Promise.reject(error);
      })
    },
    getCountry({commit, dispatch}, {journalId}) {
      let url = API.endpoints.journal + '/' + journalId + '/careplans?type=country&per_page=1'

      return Axios.get(url)
        .then(res => {
          if(res.data.careplans[0]) {
            commit('setCountry', res.data.careplans[0])
            return Promise.resolve(res.data.careplans[0])
          }
        })
        .catch(error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 });
          return Promise.reject(error);
        })
    },
    getHonorary({commit, dispatch}, {id}) {
      let honoraryID = Cons[0].GROUP_ID.honoraryBadgeActivityId[process.env.VUE_APP_DEV_STATUS]
      let url = API.endpoints.developedPlans + '?group_id=1&section=group&type=badge&published=1&user_id='+id

      commit('setHonoraryLoader', true)
      return Axios.get(url)
        .then(res => {
          commit('setHonorary', res.data.careplan.filter(e => e.id === honoraryID && e.subscribed))
          commit('setHonoraryLoader', false);
          return Promise.resolve(res.data.subscribed)
        })
        .catch(error => {
          dispatch('exceptionHandling', {_err: error}, {root: 1});
          commit('setHonoraryLoader', false);
          return Promise.reject(error)
        })
    }
  },
  getters: {
    publicUserInfo(state) {
      return state.info.data
    }
  }
}
